import React, {useState, useContext} from "react";
import { TableCell } from "@material-ui/core";
import { fmt, formatNumberToText } from "../../../util/helper";
import BuySell from "./BuySell";
import { Button } from "react-bootstrap";
import AddchartIcon from  '@mui/icons-material/CandlestickChart';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { ShowChart } from "@material-ui/icons";
import AppContext from "../../../context/Context";

const DataTableCell = ({isPosition, rowHover, info, rowData, strike ,id,  align, val, withoutLotval, decimals, isChg, cls, cellType, isString, minWidth,tokens, showBuySell=true, onChangeToggle, selectedStrikes, lotSizeEnabled, oicepeData, page, comp, middleStrike,   buySellClick, straddlePrice, chartClick, onLtpClick
  ,posNetQty, isFlipped}) => {

  const {
    config: { isDark }
  } = useContext(AppContext);
  const [hoverValue, setHoverValue] = useState('');
  const postionList = useSelector((state) => state?.orders);

  const cls2 = isChg ? val > 0 ? 'positive-chg' : val < 0 ? 'negative-chg': '': '';
  const middleStrikecls =  middleStrike == strike ? "middle-strike-cls"  : "";
  var cls3 = "";
  if(comp == "pcr" && id == "pcrPE") {
     cls3 = "";
  } else {
     cls3 = cellType === "CE" ? 'ce' :  cellType === "PE" ? 'pe': '';
  }
  const ltpColorClass = id === "lpCE" ? "call-ltp-color" : id === "lpPE" ? "put-ltp-color" : "";
  const token = cellType === "CE" ? tokens.CE : tokens.PE;
  const showValueInClass = (id === 'buildupPE' || id === 'buildupCE' || id === 'trendCE' || id === 'trendPE');
  const width = `min-w-${minWidth}`; 
  const isCheckbox = id.includes('chkbox')
  let checked = false
  const textEnd = !isString &&  id != "strike" && id != "pcrPE"  ? "text-end" :  ""; 
  if(isCheckbox || comp == "pcr" || comp=="gex"){
    const currStrike = selectedStrikes.find(stk=>stk.strike===strike)||{}
    const enabledKey = cellType === "PE" ? 'enablePE': 'enableCE'
    checked = currStrike[enabledKey]||false
  }
  var Linewidth = 0;
  if(oicepeData) {
     var tdSplit = 0.9;
       Linewidth = (id=="lpCE" ?  rowData.oiCE / oicepeData.ceoiPer  : id=="lpPE" ? rowData.oiPE / oicepeData.peoiPer : 0)*tdSplit; 
       if(isNaN(Linewidth)) {
        Linewidth = 0
       }
    }
 
  const handleRowHover = (e, tokens, cellType) => {
   setHoverValue(tokens)
 
   };
  const handleRowHoverLeave = (e, tokens, cellType) => {
    setHoverValue("")
  };
 
  const getPosValue = (strikePrice, cellType) => {
 
    const filter = postionList?.positions?.filter((item)=>info.selectExpiry ===moment(item.instrument.expiry).format("YYYY-MM-DD") && item.instrument.instrumentType === cellType && item.instrument.strikePrice === strikePrice);   
    if(filter && filter.length > 0) {
     let sum = 0;
      for (let key in filter) {
        sum += (filter[key].netQuantity/filter[key].instrument.lotSize) > 0 ? filter[key].netQuantity/filter[key].instrument.lotSize:filter[key].netQuantity/filter[key].instrument.lotSize;
      }
      return sum != 0 ? sum > 0 ? '+'+sum :sum : 0;
       //return (filter.netQuantity/filter.instrument.lotSize) > 0 ? '+'+filter.netQuantity/filter.instrument.lotSize:filter.netQuantity/filter.instrument.lotSize;
    }   
  }
 

  return (
    <TableCell
      onMouseLeave={(e) => handleRowHoverLeave(e, tokens, cellType)}
      onMouseEnter={(e) => handleRowHover(e, tokens, cellType)}
      id={(comp == "pcr" || comp == "gex") && id == "strike" ? '' : strike + '-' + id}
      className={`acion-wrap ${'div-' + id} ${middleStrikecls} ${textEnd} ${cls} ${cls2} ${cls3} ${width} ${showValueInClass ? val : ''} ${ltpColorClass}`} align={align} key={id}>
      {
        <div className="opt-p-btn" style={{ position: "relative" }}>

          {(id === "lpCE")
            && <div className={hoverValue.CE == tokens.CE ? 'bs-btn ltp-b-s-btn active-buy-sell' : 'bs-btn ltp-b-s-btn in-active-buy-sell'}>
              <Button size="sm"  className="oc-btn btn-chart" onClick={() => chartClick(rowData, cellType, strike, 'straddle', false)}><ShowChart /></Button>
              <Button onMouseLeave={(e) => rowHover("B", "ce", rowData, false, 'op', 'l')} onMouseEnter={(e) => rowHover("B", "ce", rowData, false, 'op', 'e')} size="sm"  className="oc-btn qt-buy-btn" onClick={() => buySellClick("BUY", rowData, tokens, cellType, strike, false, 'singleLeg')}>B</Button>
              <Button onMouseLeave={(e) => rowHover("S", "ce", rowData, false, 'op', 'l')} onMouseEnter={(e) => rowHover("S", "ce", rowData, false, 'op', 'e')} size="sm"  className="oc-btn qt-sell-btn" onClick={() => buySellClick("SELL", rowData, tokens, cellType, strike, false, 'singleLeg')}>S</Button>
            </div>
          }
          {(id == "strike" && isPosition && postionList?.positions.filter((item) => item.netQuantity != 0).length > 0) &&
            <div className="pos-qty-ce" style={{ visibility: !getPosValue(strike, "CE") ? "hidden" : "visible" }}>
              <span style={{ backgroundColor: getPosValue(strike, "CE") > 0 ? '#1677ff' : '#c42f4a', fontWeight: 600, color: "#fff", borderRadius: "0.25rem", paddingInline: "3px", fontSize: "10px", height: "18px", display: "flex", alignItems: "center" }}>{getPosValue(strike, "CE")}</span>
              <span className={getPosValue(strike, "CE") > 0 ? 'triangle-right' : 'triangle-left'}></span>
            </div>

          }
          <span
            id={strike + '-' + id + '-price'}
            className={id === "straddlePrice" ? "ltpCell" : ""}
            onClick={() => {
              if ((id === "lpCE" || id === "lpPE") && onLtpClick) {
                onLtpClick(rowData, cellType, strike, id);
              }
            }}
            style={{
              cursor: (id === "lpCE" || id === "lpPE") ? "pointer" : "default",
              userSelect: "none",
              color: isDark && (id === "deltaCE" || id === "deltaPE") ? "#D9D9D9" : "inherit"
            }}
          >
            {id == "straddlePrice" ? straddlePrice : id == "synFut" ? "-" : id == "oiCE" || id == "oiPE" || id == "oiChgCE" || id == "oiChgPE" ? formatNumberToText(val) : !isNaN(val) ? fmt(val ? decimals === -1 ? val : val.toFixed(decimals) : val === 0 ? 0 : '-') : ""}
          </span>

          {(id == "strike" && isPosition && postionList?.positions.filter((item) => item.netQuantity != 0).length > 0) &&
            <div className="pos-qty-pe" style={{ visibility: !getPosValue(strike, "PE") ? "hidden" : "visible" }}>

              <span className={getPosValue(strike, "PE") > 0 ? 'triangle-right' : 'triangle-left'}></span>
              <span style={{ backgroundColor: getPosValue(strike, "PE") > 0 ? '#1677ff' : '#c42f4a', fontWeight: 600, color: "#fff", borderRadius: "0.25rem", paddingInline: "3px", fontSize: "10px", height: "18px", display: "flex", alignItems: "center" }}>{getPosValue(strike, "PE")}</span>
            </div>
          }
          {(id === "lpPE")
            && <div className={hoverValue.PE == tokens.PE ? 'bs-btn ltp-b-s-btn active-buy-sell' : 'bs-btn ltp-b-s-btn in-active-buy-sell'}>
              <Button size="sm" className="oc-btn btn-chart" onClick={() => chartClick(rowData, cellType, strike, 'straddle', false)}><ShowChart /></Button>
              <Button onMouseLeave={(e) => rowHover("B", "pe", rowData, false, 'op', 'l')} onMouseEnter={(e) => rowHover("B", "pe", rowData, false, 'op', 'e')} size="sm"  className="oc-btn qt-buy-btn" onClick={() => buySellClick("BUY", rowData, tokens, cellType, strike, false, 'singleLeg')}>B</Button>
              <Button onMouseLeave={(e) => rowHover("S", "pe", rowData, false, 'op', 'l')} onMouseEnter={(e) => rowHover("S", "pe", rowData, false, 'op', 'e')} size="sm"  className="oc-btn qt-sell-btn" onClick={() => buySellClick("SELL", rowData, tokens, cellType, strike, false, 'singleLeg')}>S</Button>
            </div>
          }
          {(id === "straddlePrice")
            && <div className={hoverValue.PE == tokens.PE ? 'ltpCell bs-btn ltp-b-s-btn active-buy-sell' : 'ltpCell bs-btn ltp-b-s-btn in-active-buy-sell'}>
              <Button size="sm" className="oc-btn btn-chart" onClick={() => chartClick(rowData, cellType, strike, 'straddle', true)}><ShowChart /></Button>
              <Button onMouseLeave={(e) => rowHover("B", "ce", rowData, true, 'op', 'l')} onMouseEnter={(e) => rowHover("B", "ce", rowData, true, 'op', 'e')} size="sm"  className="oc-btn qt-buy-btn" onClick={() => buySellClick("BUY", rowData, tokens, cellType, strike, true, 'straddle')}>B</Button>
              <Button onMouseLeave={(e) => rowHover("S", "ce", rowData, true, 'op', 'l')} onMouseEnter={(e) => rowHover("S", "ce", rowData, true, 'op', 'e')} size="sm"  className="oc-btn qt-sell-btn" onClick={() => buySellClick("SELL", rowData, tokens, cellType, strike, true, 'straddle')}>S</Button>
            </div>
          }
          {(id === "synFut")
            && <div className={hoverValue.PE == tokens.PE ? 'ltpCell bs-btn ltp-b-s-btn active-buy-sell' : 'ltpCell bs-btn ltp-b-s-btn in-active-buy-sell'}>
              <Button onMouseLeave={(e) => rowHover("B", "ce", rowData, true, 'synFut', 'l')} onMouseEnter={(e) => rowHover("B", "ce", rowData, true, 'synFut', 'e')} size="sm"  className="oc-btn qt-buy-btn" onClick={() => buySellClick("BUY", rowData, tokens, cellType, strike, true, 'synFut')}>B</Button>
              <Button onMouseLeave={(e) => rowHover("S", "ce", rowData, true, 'synFut', 'l')} onMouseEnter={(e) => rowHover("S", "ce", rowData, true, 'synFut', 'e')} size="sm"  className="oc-btn qt-sell-btn" onClick={() => buySellClick("SELL", rowData, tokens, cellType, strike, true, 'synFut')}>S</Button>
            </div>
          }
        </div>
      }
      {oicepeData && id === "lpCE" &&
        <span className={isFlipped ? "postive_chg_v" : "nagtive_chg_v"} style={{ width: Linewidth + "%", background: '#cf3b17' }}></span>
      }
      {oicepeData && id === "lpPE" &&
        <span className={isFlipped ? "nagtive_chg_v" : "postive_chg_v"} style={{ width: Linewidth + "%", background: '#3ec124' }}> </span>
      }


    </TableCell>
  );
};

export default DataTableCell;
